import { getUrl } from "utils";
import client from "utils/connected/api";
import { SortOrder } from "constants/general";

export const getTracksRequest = (filterParams) => client.post(`scrape-tasks/search`, filterParams);

export const deleteTrackRequest = (id) => client.delete(`scrape-task/${id}`);

export const getCountTracksRequest = (filterParams) => client.post("scrape-tasks/search/count", filterParams);

export const getTrackProgressInfoRequest = ({ id, code, storage_type_code }) => {
    const progressInfoUrlParams = {
        limit: 0,
        initial_track_id: id,
        status_type_code: code,
        storage_type_code
    };

    return client.post("scrape-tasks/search/count", progressInfoUrlParams).then(data => ({ code, ...data }));
};

export const getTemplateRequest = ({ id, storage_type_code }) => {
    const templateRequestUrlParams = {
        initial_track_id: id,
        storage_type_code
    };

    return client.get(getUrl("templates", templateRequestUrlParams));
};

export const templateCountRequest = ({ id, code, storage_type_code }) => {
    const templateRequestUrlParams = {
        limit: 0,
        initial_track_id: id,
        template_code: code,
        storage_type_code
    };

    return client.post("scrape-tasks/search/count", templateRequestUrlParams).then(data => ({ code, ...data }));
};

export const getNoticeByTrackIdRequest = (id) => {
    const noticeUrlParams = {
        limit: 0,
        initial_track_id: id,
        status_type_code: "DONE",
        storage_type_code: "HOT",
        has_message: true
    };

    return client.post("scrape-tasks/search/count", noticeUrlParams);
};

export const getTrackWithOldestTimeRequest = ({ id , storage_type_code }) => {
    const trackWithOldestTimeUrlParams = {
        limit: 1,
        initial_track_id: id,
        sort_field: "_created",
        sort_direction: SortOrder.desc,
        storage_type_code
    };

    return client.post("scrape-tasks/search", trackWithOldestTimeUrlParams);
};

export const getTrackFullMessageRequest = ({ track_id, initial_track_id, storage_type_code }) => client.get(
    `scrape-task/${track_id}/full-message?initial_track_id=${initial_track_id}&storage_type_code=${storage_type_code}`
);
